export default {"src":"/_next/static/media/startup-logo5.3fb4da2e.svg","height":159,"width":600,"blurWidth":0,"blurHeight":0};